import ListFilters from "@/common/components/ListFilters";
import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { dashboardFilters } from "@/features/company/constants/dashboards/dashboardFilters.constant";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";
import { useEstablishmentCompanies } from "@/features/companyBranches/hooks/useEstablishmentCompanies";
import { EstablishmentCompanyTransformer } from "@/features/companyBranches/services/establishmentCompanyTransformer";

const DashboardFilterEstablishmentBranchBadge = ({ filters, setFilters }: DashboardFilterProps) => {
  const [search, setSearch] = useDebounce('');

  const {
    data: establishmentBranchOptions,
  } = useEstablishmentCompanies({
    filters: {
      search,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: EstablishmentCompanyTransformer.optionTransformer({
        valueFieldName: 'matrix_branch_id',
      }),
    }),
  });

  return (
    <ListFilters
      filters={[
        {
          className: 'bg-blue-200/20 rounded-xl shadow-none max-w-[200px] text-nowrap',
          placeholder: dashboardFilters[DashboardFilters.EstablishmentBranch],
          options: [{ label: 'Todas', value: '' }, ...establishmentBranchOptions],
          value: filters[DashboardFilters.EstablishmentBranch],
          onChange: (e: any) => setFilters((prev) => ({ ...prev, [DashboardFilters.EstablishmentBranch]: e?.value ? e : null })),
          onInputChange: setSearch,
          filterOption: () => true,
        }
      ]}
    />
  );
}

export default DashboardFilterEstablishmentBranchBadge;
